module.exports = __webpack_public_path__ + "img/home-restaurant-thumb-03-on.f62cb101.jpg";